import script from "./docBioAddLists.vue?vue&type=script&setup=true&lang=js"
export * from "./docBioAddLists.vue?vue&type=script&setup=true&lang=js"

import "./docBioAddLists.vue?vue&type=style&index=0&id=084ff5be&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-084ff5be"]])

export default __exports__